import type { ReactNode } from 'react';
import clsx from 'clsx';
import { CurrencyDisplay } from './CurrencyDisplay';

interface StatCardProps {
  title: string;
  value: ReactNode;
  /** If set, renders value as CurrencyDisplay with SAR icon instead of raw text */
  currency?: string;
  icon?: ReactNode;
  trend?: { value: number; label?: string };
  className?: string;
  onClick?: () => void;
}

export function StatCard({ title, value, currency, icon, trend, className, onClick }: StatCardProps) {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'relative rounded-xl border border-border-default bg-bg-secondary p-5 shadow-sm',
        'transition-all duration-200',
        'hover:-translate-y-1 hover:shadow-md',
        'before:absolute before:inset-x-0 before:top-0 before:h-0.5 before:rounded-t-xl before:bg-accent before:opacity-0 before:transition-opacity before:duration-200 hover:before:opacity-100',
        onClick && 'cursor-pointer',
        className,
      )}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold text-text-secondary uppercase tracking-wider">{title}</p>
          <p className="mt-2 text-2xl font-bold">
            {currency ? <CurrencyDisplay amount={typeof value === 'number' ? value : 0} currency={currency} /> : value}
          </p>
          {trend && (
            <p className={clsx('mt-1 text-xs font-medium', trend.value >= 0 ? 'text-success' : 'text-danger')}>
              {trend.value >= 0 ? '+' : ''}{trend.value}%
              {trend.label && <span className="text-text-muted ms-1">{trend.label}</span>}
            </p>
          )}
        </div>
        {icon && (
          <div className="rounded-lg bg-accent/15 p-2.5 text-accent">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
